export const TUTO_CHALLENGE_ID = process.env.TUTO_CHALLENGE_ID || '84';
export const TUTO_CHALLENGE_URL = `/player/challenge/${TUTO_CHALLENGE_ID}/tokatab-apprentissage/au-clair-de-la-lune?tuto=true`;